// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.simple-spinner {
  width: 40px;
  height: 40px;
  position: relative;
  margin: auto;
}

.double-bounce1, .double-bounce2 {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: #007bff;
  opacity: 0.6;
  position: absolute;
  top: 0;
  left: 0;
  animation: bounce 2s infinite ease-in-out;
}

.double-bounce2 {
  animation-delay: -1s;
}

@keyframes bounce {
  0%, 100% {
    transform: scale(0);
  }
  50% {
    transform: scale(1);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/common/simple-spinner/simple-spinner.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;AACF;;AACA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,yCAAA;AAEF;;AAAA;EACE,oBAAA;AAGF;;AADA;EACE;IAAW,mBAAA;EAKX;EAJA;IAAM,mBAAA;EAON;AACF","sourcesContent":[".simple-spinner {\n  width: 40px;\n  height: 40px;\n  position: relative;\n  margin: auto;\n}\n.double-bounce1, .double-bounce2 {\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  background-color: #007bff;\n  opacity: 0.6;\n  position: absolute;\n  top: 0;\n  left: 0;\n  animation: bounce 2.0s infinite ease-in-out;\n}\n.double-bounce2 {\n  animation-delay: -1.0s;\n}\n@keyframes bounce {\n  0%, 100% { transform: scale(0.0); }\n  50% { transform: scale(1.0); }\n} "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
